import { useSelector } from 'react-redux';
import { useQuery } from '@tanstack/react-query';

import { FeatureFlags } from '@buy-viasat/types/build/bv';
import { selectAccessToken } from '@buy-viasat/redux/src/auth';
import { selectLoadedFeatureFlags } from '@buy-viasat/redux/src/app';
import api, { apiEndpoints, QueryKeys } from '../../../services/axios';
import { USE_NEW_API } from '../constants';

export function useGetFeatureFlags() {
  const accessToken = useSelector(selectAccessToken);
  const loadedFeatureFlags = useSelector(selectLoadedFeatureFlags);

  const response = useQuery<FeatureFlags>({
    queryKey: [QueryKeys.getFeatureFlags],
    queryFn: async () => {
      const response = await api.get(apiEndpoints.getFeatureFlags);
      return response.data;
    },

    enabled: USE_NEW_API && Boolean(accessToken) && !loadedFeatureFlags,
  });

  return response;
}
